import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules'; 
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { Button, Form, Input, Row, Col, message, Layout, Card, Tabs, Modal } from 'antd';
import JSString from 'kts-scaffold-framework/utils/kit/JSString';
import { connect, MyStore } from 'kts-platform-frame/redux';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
// import SiteLogo from './Logo';
const { Header, Content } = Layout;
const FormItem = Form.Item;
const logoImg = require('./img/LOGO.png');
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UserJoinCompany extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            companyName:'',
            gUserId:'',
            inviteName:'',
            // ticket: this.props.location.query.ticket,
            forgetPsdModalVisible: false,
            sendSuccessMaile: '',
        };
    }  
    
    componentWillMount() {
        const params = JSString.queryStringParse(this.props.location.search);
        let ticket = params.ticket;
    }

    render() {    
        const { config } = MyStore.instance.getState();
        const _config = JSON.parse(JSON.stringify(config)); 
        return (
            <Layout className="invit-login">
                <Header className="top header"> 
                    <div className="logo">
                        <div className="left"><img alt={'logo'} src={logoImg} /></div>
                        <div className="left site-name">{ _config.rootConfig.SiteName}</div>
                    </div>
                </Header>
                <Content style={{ background: '#f0f2f5' }}>
                    <div className="invit-login-content">
                        <div className='content-info'>
                            您还没有创建平台账号，请联系您所在公司的管理员。
                        </div> 
                    </div>
                </Content>
            </Layout>
        );
    }
}




// WEBPACK FOOTER //
// ./src/display/modules/Home/Login/UI.User.ConnectAdmin.tsx